module.exports = __webpack_public_path__ + "static/media/ad.fb24751c.png";